import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpErrorResponse } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, distinct } from 'rxjs/operators';
import { UploadResponse } from '../data/file-upload-response.model';
import { SasResponse } from '../data/file-upload-sas-response';
import { FileList } from '../data/file-list.model';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FileUploadService {
    private apiURL = `${environment.apiUrl}/api/Files`;

    constructor(private http: HttpClient) { }

    uploadFile(file: File, year: string, username: string): Observable<UploadResponse> {
        const url = `${this.apiURL}/uploadFile?username=${username}&year=${year}`;
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<UploadResponse>(url, formData)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    const response: UploadResponse = {
                        success: false,
                        errorMessage: error.message
                    };
                    return throwError(() => response);
                })
            );
    }

    generateSas(userId: string, fileName: string, year: string): Observable<SasResponse> {
        const url = `${this.apiURL}/generate-sas`;
        var now = new Date();
        const guid = this.generateGUID();
        const modifiedFileName = `${guid}-${fileName}`;
        return this.http.post<SasResponse>(
            url,
            {
                UserId: userId,
                Year: year,
                FileName: modifiedFileName
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    generateGUID(): string {
        // Simple RFC4122 version 4 compliant GUID
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    uploadWithProgress(sasUrl: string, file: File) {
        return this.http.put(sasUrl, file, {
            reportProgress: true,
            observe: 'events',
            headers: {
                'x-ms-blob-type': 'BlockBlob',
                'Content-Type': file.type
            }
        });
    }

    getUserYears(userId: string) {
        const url = `${this.apiURL}/listUserYears?userId=${userId}`;
        return this.http.get<string[]>(url);
    }

    getFiles(userId: string, years: string): Observable<FileList[]> {
        const url = `${this.apiURL}/listFiles?userId=${userId}&year=${years}`;
        return this.http.get<FileList[]>(url);
    }

    viewFile(fileName: string): Observable<SasResponse> {
        const url = `${this.apiURL}/read-sas?blobName=${fileName}`;
        return this.http.get<SasResponse>(url);
    }

    downloadBlob(blobSasUrl: string) {
        return this.http.get(blobSasUrl, { responseType: 'blob' });
    }

}